import { DtoInclude, DtoRefList } from '../../../core/store/dto/dto';
import { AccountObjectDto } from '../account-object/account-object.dto';

export class CategoryGroupDto extends AccountObjectDto {
    @DtoInclude
    title: string;
    @DtoRefList
    categories: Array<string>;
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/category-group/category-group.dto.ts